import { navigations } from 'app/navigations'
import { SET_USER_NAVIGATION } from '../actions/NavigationAction'

// var newnavigations=navigations()
// const initialState = [...newnavigations]
// const initialState = [...navigations]

const NavigationReducer = function (state = [], action) {

    switch (action.type) {
        case SET_USER_NAVIGATION: {
            return [...action.payload]
        }
        default: {
            return [...state]
        }
    }
}

export default NavigationReducer
